import { render, staticRenderFns } from "./List.vue?vue&type=template&id=330a7e5f&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=330a7e5f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330a7e5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330a7e5f')) {
      api.createRecord('330a7e5f', component.options)
    } else {
      api.reload('330a7e5f', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=330a7e5f&scoped=true", function () {
      api.rerender('330a7e5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/List.vue"
export default component.exports